// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3O6AA","footer":"ModalCreateQualiphyProcedure_footer__1-E8H","additionData":"ModalCreateQualiphyProcedure_additionData__2zCUS"};